import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycMedicaidApplicationProcessPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-medicaid-application-process/']} />;
}
